export default "__VITE_PUBLIC_ASSET__4353e063__"